import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert
  } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { RuleCard } from "components/RuleCard/RuleCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import moment from "moment";
import { fetchEmployeeTypeRequest, createEmployeeTypeRequest, editEmployeeTypeRequest } from "../../../api/employeeType";
import { attendanceRuleSelectOptionRequest } from "../../../api/attendanceRule";
import { 
  longevityRuleSelectOptions,
  holidayRuleSelectOptions,
  restdayRuleSelectOptions
} from "../../../variables/Variables.jsx";

class EmployeeTypeForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      resource: {
        employeeType: '',
        factor: '',
        lateRuleEffectiveDate: '',
        undertimeRuleEffectiveDate: '',
        absentRuleEffectiveDate: '',
        longevityRule: '',
        holidayRule: '',
        restdayRule: '',
        mondaySchedule: {},
        tuesdaySchedule: {},
        wednesdaySchedule: {},
        thursdaySchedule: {},
        fridaySchedule: {},
        saturdaySchedule: {},
        sundaySchedule: {},
        lateRuleArray: [],
        undertimeRuleArray: [],
        absentRuleArray: [],
        overtimeRuleArray: [],
        nightShiftRuleArray: [],
      },
      lateRuleSelectOptions: [],
      undertimeRuleSelectOptions: [],
      absentRuleSelectOptions: [],
      overtimeRuleSelectOptions: [],
      nightShiftRuleSelectOptions: [],
      error: null
    }
  }

  componentDidMount() {
    const { instanceId } = this.props;

    if (instanceId) {
      this.fetchInstance(instanceId);
    } 

    attendanceRuleSelectOptionRequest(
      "late",
      result => this.setState({ lateRuleSelectOptions: result }),
      error => this.setState({ error: "There was an error" })
    );

    attendanceRuleSelectOptionRequest(
      "undertime",
      result => this.setState({ undertimeRuleSelectOptions: result }),
      error => this.setState({ error: "There was an error" })
    );

    attendanceRuleSelectOptionRequest(
      "absent",
      result => this.setState({ absentRuleSelectOptions: result }),
      error => this.setState({ error: "There was an error" })
    );

    attendanceRuleSelectOptionRequest(
      "overtime",
      result => this.setState({ overtimeRuleSelectOptions: result }),
      error => this.setState({ error: "There was an error" })
    );

    attendanceRuleSelectOptionRequest(
      "nightShift",
      result => this.setState({ nightShiftRuleSelectOptions: result }),
      error => this.setState({ error: "There was an error" })
    );
  }

  fetchInstance = (id) => {
      fetchEmployeeTypeRequest(id,
          result => this.setState(prevState => ({
              resource: {
                  ...prevState.resource,
                  ...result
              }
          })), error => this.setState({ error: 'There was an error' }));
  }

  handleFormChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [name]: value,
      },
    }))
  }

  handleDateChange = (date, field) => {
    let value = moment(date).format("YYYY-MM-DD");

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [field]: value
      }
    }));
  };

  handleScheduleChange = (e, day) => {

    const { target } = e;
    const { name, value } = target;


    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [day]: {
          ...prevState.resource[day],
          [name]: value,
        },
      }
    }))
  }

  save = () => {
    const {
      employeeTypeName,
      factor,
      lateRuleArray,
      undertimeRuleArray,
      absentRuleArray,
      overtimeRuleArray,
      nightShiftRuleArray,
      longevityRule,
      holidayRule,
      restdayRule,
      mondaySchedule,
      tuesdaySchedule,
      wednesdaySchedule,
      thursdaySchedule,
      fridaySchedule,
      saturdaySchedule,
      sundaySchedule
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    let data = {
      employeeTypeName,
      factor,
      lateRuleArray,
      undertimeRuleArray,
      absentRuleArray,
      overtimeRuleArray,
      nightShiftRuleArray,
      longevityRule,
      holidayRule,
      restdayRule,
      mondaySchedule,
      tuesdaySchedule,
      wednesdaySchedule,
      thursdaySchedule,
      fridaySchedule,
      saturdaySchedule,
      sundaySchedule
    };

    if (isNewRecord) {
        createEmployeeTypeRequest(data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    } else {
        editEmployeeTypeRequest(instanceId, data,
            result => this.saveSuccess(),
            error => this.saveFailure()
        );
    }
  }

  saveSuccess = () => {
    this.setState({ error: null });
    this.props.goToList('employee-type');
  }

  saveFailure = (error) => {
      this.setState({ error: error.message || 'There was an error saving Employee Type.' })
  }

  addNewRule = (key) => () => {
    const updatedRuleArray = [...this.state.resource[key]];
    updatedRuleArray.push({
      rule: {},
      effectiveDateStart: '',
      effectiveDateEnd: ''
    });
    this.setState((prevState) => ({
      resource: {
        ...prevState.resource,
        [key]: updatedRuleArray
      }
    }));
  }

  render() {

    const {
      employeeTypeName,
      factor,
      longevityRule,
      holidayRule,
      restdayRule,
      mondaySchedule,
      tuesdaySchedule,
      wednesdaySchedule,
      thursdaySchedule,
      fridaySchedule,
      saturdaySchedule,
      sundaySchedule,
      overtimeRuleArray,
      nightShiftRuleArray,
      lateRuleArray,
      undertimeRuleArray,
      absentRuleArray
    } = this.state.resource;

    const {
      lateRuleSelectOptions,
      undertimeRuleSelectOptions,
      absentRuleSelectOptions,
      nightShiftRuleSelectOptions,
      overtimeRuleSelectOptions,
      error
    } = this.state;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    // const lateRuleEffectiveDate = this.state.resource.lateRuleEffectiveDate ? moment(this.state.resource.lateRuleEffectiveDate, 'YYYY-MM-DD').toDate() : '';
    // const undertimeRuleEffectiveDate = this.state.resource.undertimeRuleEffectiveDate ? moment(this.state.resource.undertimeRuleEffectiveDate, 'YYYY-MM-DD').toDate() : '';
    // const absentRuleEffectiveDate = this.state.resource.absentRuleEffectiveDate ? moment(this.state.resource.absentRuleEffectiveDate, 'YYYY-MM-DD').toDate() : '';

    return (
      <Row>
        <Col md={12}>
          <Card
            title={isNewRecord ? "New entry" : "Edit entry"}
            content={
              <form>
                <Button className="card-top-btn btn-primary" onClick={() => this.props.goToList('employee-type')}>
                  Back to List
                </Button>
                <FormGroup>
                  <ControlLabel>Employee Type <span className="required-star">*</span></ControlLabel>
                  <FormControl
                    type="text"
                    name="employeeTypeName"
                    value={employeeTypeName}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Factor <span className="required-star">*</span></ControlLabel>
                  <FormControl
                    type="text"
                    name="factor"
                    value={factor}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>
                <Alert bsStyle="info">
                  <h5>Instructions for Late, Absent and Undertime rules</h5>
                  <br />
                  1) It's mandatory to add at least one rule for each of them;
                  <br />
                  2) Leave the end date blank for "indefinite duration";
                  <br />
                  3) Make sure not to overlap dates (having 2 rules effective during the same period);
                  <br />
                  4) Make sure not to leave any period without effective rules;
                  <br />
                  5) If you're editing rules, changes will only take effect when you click on "Save Changes"
                </Alert>
                <Card 
                  hideFooter 
                  content={
                    <div>
                      <div className="add-rule-container">
                        <p className="category">Late Rules <span className="required-star">*</span></p>
                        <Button onClick={this.addNewRule('lateRuleArray')} className="pull-right" bsStyle="primary" bsSize="sm">Add Late Rule</Button>
                      </div>
                      <RuleCard rules={lateRuleArray} ruleOptions={lateRuleSelectOptions} onUpdateRules={(rules) => this.setState((prevState) => ({ resource: { ...prevState.resource, lateRuleArray: rules }}))} />  
                    </div>
                  }
                >
                </Card>
                <Card 
                  hideFooter 
                  content={
                    <div>
                      <div className="add-rule-container">
                        <p className="category">Absent Rules <span className="required-star">*</span></p>
                        <Button onClick={this.addNewRule('absentRuleArray')} className="pull-right" bsStyle="primary" bsSize="sm">Add Absent Rule</Button>
                      </div>
                      <RuleCard rules={absentRuleArray} ruleOptions={absentRuleSelectOptions} onUpdateRules={(rules) => this.setState((prevState) => ({ resource: { ...prevState.resource, absentRuleArray: rules }}))} />  
                    </div>
                  }
                >
                </Card>
                <Card 
                  hideFooter 
                  content={
                    <div>
                      <div className="add-rule-container">
                        <p className="category">Undertime Rules <span className="required-star">*</span></p>
                        <Button onClick={this.addNewRule('undertimeRuleArray')} className="pull-right" bsStyle="primary" bsSize="sm">Add Undertime Rule</Button>
                      </div>
                      <RuleCard rules={undertimeRuleArray} ruleOptions={undertimeRuleSelectOptions} onUpdateRules={(rules) => this.setState((prevState) => ({ resource: { ...prevState.resource, undertimeRuleArray: rules }}))} />  
                    </div>
                  }
                >
                </Card>
                <Card 
                  hideFooter 
                  content={
                    <div>
                      <div className="add-rule-container">
                        <p className="category">Overtime Rules <span className="required-star">*</span></p>
                        <Button onClick={this.addNewRule('overtimeRuleArray')} className="pull-right" bsStyle="primary" bsSize="sm">Add Overtime Rule</Button>
                      </div>
                      <RuleCard rules={overtimeRuleArray} ruleOptions={overtimeRuleSelectOptions} onUpdateRules={(rules) => this.setState((prevState) => ({ resource: { ...prevState.resource, overtimeRuleArray: rules }}))} />  
                    </div>
                  }
                >
                </Card>
                <Card 
                  hideFooter 
                  content={
                    <div>
                      <div className="add-rule-container">
                        <p className="category">Night Shift Differential Rules <span className="required-star">*</span></p>
                        <Button onClick={this.addNewRule('nightShiftRuleArray')} className="pull-right" bsStyle="primary" bsSize="sm">Add Night Shift Rule</Button>
                      </div>
                      <RuleCard rules={nightShiftRuleArray} ruleOptions={nightShiftRuleSelectOptions} onUpdateRules={(rules) => this.setState((prevState) => ({ resource: { ...prevState.resource, nightShiftRuleArray: rules }}))} />  
                    </div>
                  }
                >
                </Card>
                <FormGroup>
                  <ControlLabel>Longevity Rule <span className="required-star">*</span></ControlLabel>
                  <FormControl 
                      onChange={this.handleFormChange}
                      componentClass="select" 
                      name="longevityRule"
                      value={longevityRule}
                    >
                    <option value="">Select</option>
                    {longevityRuleSelectOptions.map(option => {
                      return (
                        <option
                          key={option.value}
                          value={option.value}
                          title={option.description}
                        >
                          {option.label}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Holiday Rule <span className="required-star">*</span></ControlLabel>
                  <FormControl 
                      onChange={this.handleFormChange}
                      componentClass="select" 
                      name="holidayRule"
                      value={holidayRule}
                    >
                    <option value="">Select</option>
                    {holidayRuleSelectOptions.map(option => {
                      return (
                        <option
                          key={option.value}
                          value={option.value}
                          title={option.description}
                        >
                          {option.label}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Rest Day Rule <span className="required-star">*</span></ControlLabel>
                  <FormControl 
                      onChange={this.handleFormChange}
                      componentClass="select" 
                      name="restdayRule"
                      value={restdayRule}
                    >
                    <option value="">Select</option>
                    {restdayRuleSelectOptions.map(option => {
                      return (
                        <option
                          key={option.value}
                          value={option.value}
                          title={option.description}
                        >
                          {option.label}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
                <div className="form-section-wrapper">
                  <h3 className="title">Schedule <span className="required-star">*</span></h3>
                  <label 
                    className="form-helper-text"
                    style={{
                      marginBottom: "15px"
                    }}
                  >
                    In 24 hours format, excluding seconds (eg: 14:00)
                  </label>
                  <Row
                    className="form-section"
                  >
                      <div className="col-md-12">
                        <h6>
                          Monday
                        </h6>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time In</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeIn"
                            value={mondaySchedule.timeIn}
                            onChange={(e) => this.handleScheduleChange(e, 'mondaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch Start</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchStart"
                            value={mondaySchedule.lunchStart}
                            onChange={(e) => this.handleScheduleChange(e, 'mondaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch End</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchEnd"
                            value={mondaySchedule.lunchEnd}
                            onChange={(e) => this.handleScheduleChange(e, 'mondaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time Out</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeOut"
                            value={mondaySchedule.timeOut}
                            onChange={(e) => this.handleScheduleChange(e, 'mondaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                  </Row>
                  <Row
                    className="form-section"
                  >
                      <div className="col-md-12">
                        <h6>
                          Tuesday
                        </h6>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time In</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeIn"
                            value={tuesdaySchedule.timeIn}
                            onChange={(e) => this.handleScheduleChange(e, 'tuesdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch Start</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchStart"
                            value={tuesdaySchedule.lunchStart}
                            onChange={(e) => this.handleScheduleChange(e, 'tuesdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch End</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchEnd"
                            value={tuesdaySchedule.lunchEnd}
                            onChange={(e) => this.handleScheduleChange(e, 'tuesdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time Out</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeOut"
                            value={tuesdaySchedule.timeOut}
                            onChange={(e) => this.handleScheduleChange(e, 'tuesdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                  </Row>
                  <Row
                    className="form-section"
                  >
                      <div className="col-md-12">
                        <h6>
                          Wednesday
                        </h6>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time In</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeIn"
                            value={wednesdaySchedule.timeIn}
                            onChange={(e) => this.handleScheduleChange(e, 'wednesdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch Start</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchStart"
                            value={wednesdaySchedule.lunchStart}
                            onChange={(e) => this.handleScheduleChange(e, 'wednesdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch End</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchEnd"
                            value={wednesdaySchedule.lunchEnd}
                            onChange={(e) => this.handleScheduleChange(e, 'wednesdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time Out</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeOut"
                            value={wednesdaySchedule.timeOut}
                            onChange={(e) => this.handleScheduleChange(e, 'wednesdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                  </Row>
                  <Row
                    className="form-section"
                  >
                      <div className="col-md-12">
                        <h6>
                          Thursday
                        </h6>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time In</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeIn"
                            value={thursdaySchedule.timeIn}
                            onChange={(e) => this.handleScheduleChange(e, 'thursdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch Start</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchStart"
                            value={thursdaySchedule.lunchStart}
                            onChange={(e) => this.handleScheduleChange(e, 'thursdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch End</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchEnd"
                            value={thursdaySchedule.lunchEnd}
                            onChange={(e) => this.handleScheduleChange(e, 'thursdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time Out</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeOut"
                            value={thursdaySchedule.timeOut}
                            onChange={(e) => this.handleScheduleChange(e, 'thursdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                  </Row>
                  <Row
                    className="form-section"
                  >
                      <div className="col-md-12">
                        <h6>
                          Friday
                        </h6>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time In</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeIn"
                            value={fridaySchedule.timeIn}
                            onChange={(e) => this.handleScheduleChange(e, 'fridaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch Start</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchStart"
                            value={fridaySchedule.lunchStart}
                            onChange={(e) => this.handleScheduleChange(e, 'fridaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch End</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchEnd"
                            value={fridaySchedule.lunchEnd}
                            onChange={(e) => this.handleScheduleChange(e, 'fridaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time Out</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeOut"
                            value={fridaySchedule.timeOut}
                            onChange={(e) => this.handleScheduleChange(e, 'fridaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                  </Row>
                  <Row
                    className="form-section"
                  >
                      <div className="col-md-12">
                        <h6>
                          Saturday
                        </h6>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time In</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeIn"
                            value={saturdaySchedule.timeIn}
                            onChange={(e) => this.handleScheduleChange(e, 'saturdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch Start</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchStart"
                            value={saturdaySchedule.lunchStart}
                            onChange={(e) => this.handleScheduleChange(e, 'saturdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch End</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchEnd"
                            value={saturdaySchedule.lunchEnd}
                            onChange={(e) => this.handleScheduleChange(e, 'saturdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time Out</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeOut"
                            value={saturdaySchedule.timeOut}
                            onChange={(e) => this.handleScheduleChange(e, 'saturdaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                  </Row>
                  <Row
                    className="form-section"
                  >
                      <div className="col-md-12">
                        <h6>
                          Sunday
                        </h6>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time In</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeIn"
                            value={sundaySchedule.timeIn}
                            onChange={(e) => this.handleScheduleChange(e, 'sundaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch Start</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchStart"
                            value={sundaySchedule.lunchStart}
                            onChange={(e) => this.handleScheduleChange(e, 'sundaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Lunch End</ControlLabel>
                          <FormControl
                            type="text"
                            name="lunchEnd"
                            value={sundaySchedule.lunchEnd}
                            onChange={(e) => this.handleScheduleChange(e, 'sundaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                          <ControlLabel>Time Out</ControlLabel>
                          <FormControl
                            type="text"
                            name="timeOut"
                            value={sundaySchedule.timeOut}
                            onChange={(e) => this.handleScheduleChange(e, 'sundaySchedule')}
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                  </Row>
                </div>
                
                {error &&
                  <Alert bsStyle="danger">
                    {error}
                  </Alert>
                }
                
                <Button bsStyle="primary" pullRight fill onClick={this.save}>
                  {isNewRecord ? "Create" : "Save changes"}
                </Button>
                <div className="clearfix" />
              </form>
            }
          />
        </Col>
      </Row>
    )
  }
}

export default EmployeeTypeForm;
